<template>
  <component
    v-for="section in sections"
    :is="getComponent(section)"
    v-bind="section"
    :key="section.flexKey"
  />
</template>

<script>
import SectionAd from '@/components/sections/SectionAd.vue'
import SectionCta from '@/components/sections/SectionCta.vue'
import SectionFamtours from '@/components/sections/SectionFamtours.vue'
import SectionFaq from '@/components/sections/SectionFaq.vue'
import SectionForm from '@/components/sections/SectionForm.vue'
import SectionFullWidthImage from '@/components/sections/SectionFullWidthImage.vue'
import SectionSplit from '@/components/sections/SectionSplit.vue'
import SectionStoriesToRediscover from '@/components/sections/SectionStoriesToRediscover.vue'
import SectionSwiperActivity from '@/components/sections/SectionSwiperActivity.vue'
import SectionSwiperImage from '@/components/sections/SectionSwiperImage.vue'
import SectionSwiperVoyages from '@/components/sections/SectionSwiperVoyages.vue'
import SectionTeam from '@/components/sections/SectionTeam.vue'

export default {
  name: 'PageBuilder',
  props: {
    sections: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getComponent(section) {
      switch (section.flexLayout) {
        case 'ads_section':
          return SectionAd

        case 'destinations_section':
          return SectionSwiperVoyages

        case 'destinations_slider_section':
          return SectionSwiperImage

        case 'split_destinations_section':
        case 'split_images_section':
        case 'split_single_image_section':
        case 'split_destination_image_section':
          return SectionSplit

        case 'cta_section':
          return SectionCta

        case 'famtourssection':
          return SectionFamtours

        case 'faq_section':
          return SectionFaq
        case 'form_section':
          return SectionForm
        case 'stories_to_rediscover_section':
          return SectionStoriesToRediscover
        case 'team_section':
          return SectionTeam

        case 'card_slider_section':
          return SectionSwiperActivity

        case 'full_width_image_section':
          return SectionFullWidthImage

        default:
          return 'div'
      }
    },
  },
}
</script>
